import React from "react";

export function Slagordle() {
  return (
    <span className="font-bold">
      SLAGORD<span className="text-green-600">L</span>E
    </span>
  );
}
